export const pxToRem = (value: number) => `${value / 16}rem`
